import { useCallback, useState, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

const TestimonialCarousel = ({ data }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, speed: 20 });
  const [selectedIndex, setSelectedIndex] = useState(0);

  const scrollTo = useCallback(
    (index) => {
      emblaApi && emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <SlideList data={data} />
      </div>

      <NavDots selectedIndex={selectedIndex} data={data} scrollTo={scrollTo} />
    </div>
  );
};

const SlideList = ({ data }) => {
  return (
    <div className="embla__container">
      {data.map((item, i) => {
        return <Slide key={i} slide={item} />;
      })}
    </div>
  );
};

const Slide = ({ slide }) => {
  return (
    <figure className="item embla__slide mb-0">
      <blockquote className="blockquote">
        <p className="text-white">
          <strong>{slide.body}</strong>
        </p>
      </blockquote>
      <figcaption className="pt-3 blockquote-footer text-white">{slide.author}</figcaption>
    </figure>
  );
};

const NavDots = ({ selectedIndex, data, scrollTo }) => {
  const getScrollTo = (index) => () => scrollTo(index);

  return (
    <div className="embla-dots">
      {data.map((item, index) => {
        const className = index === selectedIndex ? 'embla__dot active' : 'embla__dot';
        return (
          <button key={index} className={className} onClick={getScrollTo(index)}>
            <span></span>
          </button>
        );
      })}
    </div>
  );
};

module.exports = TestimonialCarousel;
